import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import Buttons from '../../../core/Buttons';
import { ChatStrong } from '../../../../../assets/images';
import Icon from '../../../core/Icon';
import { StyledChat, StyledAvatarPerson } from './style';
import {
  getChats,
  getChatMessages,
  getChatMembers,
  getMe
} from '../../../../utils/officeIntegration';
import Loading from '../../../core/Loading';
import { AVATAR_MEDIUM } from '../../../../utils/crops';

const MES = 2629750000;
const BASE = 'https://teams.microsoft.com/_#/conversations/';
const PARAMS = '?ctx=chat';

class WidgetChat extends Component {
  constructor(props) {
    super(props);
    this.state = { data: [], me: null };
    this.limitToShow = new Date() - MES;
  }

  componentDidMount() {
    getMe().then(data => this.setState({ me: data.displayName }));
    getChats()
      .then(chats => {
        chats.value.map(chat => {
          const { id } = chat;
          getChatMembers(id)
            .then(user => {
              const urs = user.value.map(use => use.displayName);
              if (urs.length > 1) {
                getChatMessages(chat.id)
                  .then(message => {
                    const msge = message.value[0];
                    if (msge) {
                      const { data } = this.state;
                      const newData = data;
                      const blank = {
                        id,
                        users: urs,
                        createdDateTimeHour: !msge.createdDateTime
                          ? ''
                          : moment(msge.createdDateTime).format('HH:mm'),
                        createdDateTimeDay: !msge.createdDateTime
                          ? ''
                          : moment(msge.createdDateTime).format('DD/MM'),
                        msg: {
                          txt: msge.body.content,
                          from: !msge.from.user.displayName
                            ? 'User'
                            : msge.from.user.displayName
                        }
                      };

                      newData.push(blank);
                      this.setState({ data: newData });
                    }
                  })
                  .catch(e => console.warn('>>> WidgetChat error messages', e));
              }
            })
            .catch(e => console.warn('>>> WidgetChat error members', e));
          return null;
        });
      })
      .catch(e => console.warn('>>> WidgetChat error 2', e));
  }

  render() {
    const { className } = this.props;
    const { data, me } = this.state;
    const today = new Date();
    const formatToday = moment(today).format('DD/MM');
    return (
      <StyledChat className={className}>
        <h2 className="title">
          <Icon svg={ChatStrong} className="icon-title" />
          Chat
        </h2>
        <Link className="chat-link-init" to="/widget/chat/find">
          <Buttons className="chat-btn-init" type="button" secondary>
            Iniciar conversación
          </Buttons>
        </Link>
        <p className="chat-sub-title">Conversaciones recientes</p>
        <div className="chat-content">
          {data ? (
            <ul className="chat-list">
              {data.map(chatElement => {
                if (chatElement) {
                  const {
                    id,
                    users,
                    msg,
                    createdDateTimeDay,
                    createdDateTimeHour
                  } = chatElement;
                  const user = users.filter(use => use !== me);
                  const splitUser = user[0] && user[0].split(' ');
                  return (
                    <li
                      className="chat-item"
                      key={Math.round(Math.random() * 999999)}
                    >
                      <a
                        href={`${BASE}${id}${PARAMS}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="chat-msj"
                      >
                        Ir a la conversación
                      </a>
                      <div className="chat-animation">
                        <a
                          href={`${BASE}${id}${PARAMS}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="chat-msj-animation"
                        >
                          Ir a la conversación
                        </a>
                      </div>
                      {users.length < 3 ? (
                        <StyledAvatarPerson
                          name={splitUser && splitUser[0]}
                          lastname={splitUser && splitUser[1]}
                          userId="9999999999999"
                          crop={AVATAR_MEDIUM}
                        />
                      ) : (
                        <StyledAvatarPerson
                          name="+"
                          lastname={`${users.length}`}
                          userId="999999999999"
                          crop={AVATAR_MEDIUM}
                        />
                      )}

                      <div className="chat-wrapper-msj">
                        <p className="chat-name">
                          {users.length < 3
                            ? `${user[0]}`
                            : `${user[0]}, +${users.length - 1}`}
                        </p>

                        <p className="chat-msj-txt">
                          <span>
                            {msg.from === users[0] ? 'Yo' : msg.from}:{' '}
                          </span>
                          <span
                            // eslint-disable-next-line react/no-danger
                            dangerouslySetInnerHTML={{
                              __html: msg.txt.replace(/div/g, 'span')
                            }}
                          />
                        </p>
                      </div>

                      <p className="chat-time">
                        {createdDateTimeDay === formatToday
                          ? createdDateTimeHour
                          : createdDateTimeDay}
                      </p>
                    </li>
                  );
                }
                return null;
              })}
            </ul>
          ) : (
            <Loading txt="Cargando conversaciones..." size="l" color="light" />
          )}
        </div>
      </StyledChat>
    );
  }
}

export default WidgetChat;
